import React, { Component } from 'react';
//import { RouteComponentProps } from 'react-router';
//import { CSSProperties } from 'react';
import * as pbi from 'powerbi-client';
//import * as $ from 'jquery';

const powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);

export class Analytics extends Component {

    constructor(props) {
        super(props);
        this.state = { loading: true };
        // get list of reports
        fetch('api/analytics/all')
            .then(response => response.json())
            .then(data => {
                this.setState({ reports: data, loading: false })
            });
    }

    render() {
        let reportList = this.state.loading
            ? <p style={{ padding: '10px' }}><em>Loading...</em></p>
            : this.renderReportList(this.state.reports);
        let embeddedReport = this.state.loading
            ? <p></p>
            : this.initEmbeddedReport();
        return <div>
            <h1>Analytics</h1>
            {reportList}
            <h1>Embedded</h1>
            <br />
            <br />
            <div>
                <p>{this.state.siteSelectedText}</p>
            </div>
            {embeddedReport}
        </div>;
    }

    renderReportList(reports) {
        return <table className='table'>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Id</th>
                    <th>EmbedUrl</th>
                </tr>
            </thead>
            <tbody>
                {reports.map(report =>
                    <tr key={report.name}>
                        <td>{report.name}</td>
                        <td>{report.id}</td>
                        <td>{report.embedUrl}</td>
                        <td><button onClick={() => this.refreshEmbed(report)}>Me!</button></td>

                    </tr>
                )}
            </tbody>
        </table>;
    }

    initEmbeddedReport() {
        let style = { height: "600px", width: "100%", maxWidth: "1000px" };
        return <div className="embedWrapper" >
            <div id="embedDiv" className="powerbi-container" style={style} />
        </div>;
    }

    refreshEmbed(report) {
        console.log(this.state.selectedRLSValue)

        if (report == null) report = this.status.reports[0];

        // use selectedRLS value and query embed token
        var requestBody = JSON.stringify(
            {
                reportId: report.id,
                datasetId: report.datasetId,
                rlsValue: this.state.selectedRLSValue,
                accessLevel: this.state.inEditMode
            });

        fetch('api/analytics/embedtoken', {
            method: 'POST',
            body: requestBody,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
        })
            .then(response => response.json())
            .then(data => {
                console.log('embed token for ' + this.state.selectedRLSValue + ': ' + data);
                report.userEmbedToken = data;
                this.embedReport(report);
            });
    }

    embedReport(report) {
        let accessToken = report.userEmbedToken;
        // Render report
        let reportId = report.id;
        let embedUrl = report.embedUrl;
        let config = {
            type: "report",
            tokenType: pbi.models.TokenType.Embed,
            accessToken: accessToken,
            embedUrl: embedUrl,
            id: reportId,
            permissions: pbi.models.Permissions.All,
            viewMode: pbi.models.ViewMode.Edit,
            //filters: 
            settings: {
                filterPaneEnabled: true,
                navContentPaneEnabled: true
            }
        };
        let embedDiv = document.getElementById('embedDiv');
        if (embedDiv != null) {
            powerbi.reset(embedDiv);
            let embeddedReport = powerbi.embed(embedDiv, config);
            if (embeddedReport.embeType !== 'report') return;
        }
    }
} 


// WEBPACK FOOTER //
// ./src/components/Analytics/Analytics.js